import { useEffect } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';
import {
  IBrandingEditorLockStatePayload,
  LastWebsocketJsonMessageType,
  WebsocketAction,
} from '@interfaces/webSocketConnectionInfo';

/**
 * The experience's Editor Mode lock changed hands or was released.
 *
 * The backend broadcasts `BRANDING_EDITOR_LOCK_STATE` to every hub in the
 * experience on acquire, release and takeover; this puts the state where the
 * Admin Tools button and the lock lifecycle read it.
 *
 * @param lastJsonMessage - Latest message off the dashboard websocket. Anything
 * other than `BRANDING_EDITOR_LOCK_STATE`, or a state for another experience,
 * is ignored.
 */
export const useHandleBrandingEditorLockMsg = (
  lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  const { currentEventId, setBrandingEditorLockState } = useMytaverseEvent();

  useEffect(() => {
    if (!lastJsonMessage) {
      return;
    }

    if (lastJsonMessage.action !== WebsocketAction.BrandingEditorLockState) {
      return;
    }

    const payload =
      lastJsonMessage as unknown as IBrandingEditorLockStatePayload;

    if (!payload.eventId || payload.eventId !== currentEventId) {
      return;
    }

    setBrandingEditorLockState({
      eventId: payload.eventId,
      lock: payload.lock ?? null,
      heartbeatIntervalMs: payload.heartbeatIntervalMs,
      staleAfterMs: payload.staleAfterMs,
      serverTime: payload.serverTime,
    });
  }, [lastJsonMessage, currentEventId, setBrandingEditorLockState]);
};
